import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

export const SaveToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)
